module.exports = __webpack_public_path__ + "static/media/mitsubishi-star.0f19691d.svg";